import { IBaseMigrationItemCode } from '../../../interfaces';
import { BaseItemCodeToConditionMappingHandler } from '../../../mappings/base-item-code-to-condition';
import {
  ADAItemSourceEntity,
  ExactADAItem,
  IExactADAItem,
} from '../../../exact/source/entities/ada-item';
import { PracticeWorksUsedItemCodeConditionSourceEntity } from '../../source/entities/used-item-code-conditions';

export class PracticeWorksItemCodeToConditionMappingHandler extends BaseItemCodeToConditionMappingHandler<
  ExactADAItem,
  ADAItemSourceEntity
> {
  sourceEntity = new PracticeWorksUsedItemCodeConditionSourceEntity();
  translateFn = (record: IExactADAItem): IBaseMigrationItemCode => ({
    id: record.itemCode,
    itemCode: record.itemCode,
    description: record.description ?? '',
  });
}
